<template>
  <div :class="`follow_drawer ${!collapsed ? 'shadow' : ''} ${mode()}`" :style="`zIndex:${collapsed ? 1001 : 1002}`">
    <div class="follow_drawer_toggle shadow" @click="toggle">待 跟 进</div>
    <div v-if="!fullPage" class="full-width full-height flex-column">
      <div class="follow_drawer_tabs flex-row col-0">
        <div
          v-for="n in 5"
          :key="n"
          :class="`follow_drawer_tabs_item col-1 ${n === tab ? 'follow_drawer_tabs_item_actived' : ''}`"
          @click="onSelectTab(n)"
        >
          {{ tomorrow(n - 1) }}
        </div>
        <div class="follow_drawer_tabs_item col-1" @click="fullPage = true">汇总</div>
      </div>
      <RadishTableMin :list="list" :handleRemove="handleRemove" />
    </div>
    <div v-else class="full-width full-height flex-column">
      <div class="flex-row item-center pd-10 col-0">
        <el-date-picker
          v-model="timeRange"
          :picker-options="pickerOptions"
          type="daterange"
          align="right"
          size="mini"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          class="mini_datetime_picker"
        />
        <a href="javascript:void(0);" class="follow_drawer_btn m-a-10" @click="fullPage = false">返回</a>
      </div>
      <RadishTableMax :list="fullList" :handleRemove="handleRemove" />
    </div>
  </div>
</template>

<script>
import RadishTableMin from './RadishTableMin.vue'
import RadishTableMax from './RadishTableMax.vue'
import { tomorrow } from '../constant/utils'

export default {
  name: 'FollowDrawer',
  components: {
    RadishTableMax,
    RadishTableMin,
  },
  data() {
    return {
      collapsed: true,
      tab: 1,
      fullPage: false,
      list: [],
      fullList: [],
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            },
          },
        ],
      },
      timeRange: undefined,
    }
  },
  computed: {
    tomorrow() {
      return tomorrow
    },
  },
  watch: {
    tab: {
      async handler(val, old) {
        this.loadData()
      },
    },
    timeRange: {
      async handler(val) {
        if (!val || val.length === 0) {
          const end = new Date()
          const start = new Date()
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
          this.timeRange = [start, end]
          return
        }
        this.loadFullData({
          startTime: new Date(val[0]).valueOf(),
          endTime: new Date(val[1]).valueOf(),
        })
      },
    },
    collapsed(val) {
      if (!val) this.loadData()
    },
    fullPage(val) {
      if ((!this.timeRange || this.timeRange.length === 0) && val) {
        const end = new Date()
        const start = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
        this.timeRange = [start, end]
      }
    },
  },
  methods: {
    async loadData(param) {
      const offset = param || this.tab - 1
      this.list = await window.app.service('project').followList({
        offset,
      })
    },
    async loadFullData(params) {
      const { startTime, endTime } = params
      this.fullList = await window.app.service('project').followList({
        startTime,
        endTime,
        attachments: 1,
      })
    },
    mode() {
      if (this.fullPage) {
        return this.collapsed ? 'follow_drawer_full_collapsed' : 'follow_drawer_full'
      }
      return this.collapsed ? 'follow_drawer_mini_collapsed' : 'follow_drawer_mini'
    },
    toggle() {
      this.collapsed = !this.collapsed
    },
    onSelectTab(val) {
      this.tab = val
    },
    async handleRemove(row) {
      console.log(row)
      try {
        await window.app.service('project').followRemove(row._id)
        try {
          this.loadData()
        } catch (error) {
          console.error(error)
        }
      } catch (error) {
        this.$message.error(error.message)
      }
    },
  },
}
</script>

<style>
.follow_drawer {
  position: fixed;
  top: 61px;
  right: 0;
  bottom: 0;
  left: 0;
  border-radius: 0 !important;

  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  background-color: #fff;
  transition: all 0.1s ease-out;
}
.follow_drawer_mini {
  width: 250px;
}
.follow_drawer_mini_collapsed {
  width: 250px;
  transform: translate(-250px);
}
.follow_drawer_full {
  width: 100%;
}
.follow_drawer_full_collapsed {
  width: 100%;
  transform: translate(-100%);
}
.follow_drawer_toggle {
  position: absolute;
  right: -25px;
  top: 350px;
  line-height: 25px;
  padding: 10px 0 10px 0;
  border-radius: 0 4px 4px 0;
  background-color: #01487e;
  color: #fff;
  cursor: pointer;
  writing-mode: tb-rl;
  -webkit-writing-mode: vertical-rl;
}
.follow_drawer_tabs {
  height: 30px;
  line-height: 30px;
}
.follow_drawer_tabs_item {
  text-align: center;
  cursor: pointer;
  border-bottom: 2px solid #409eff;
}
.follow_drawer_tabs_item:hover {
  color: #409eff;
}
.follow_drawer_tabs_item_actived {
  border-right: 2px solid #409eff;
  border-left: 2px solid #409eff;
  border-bottom: 1px solid #fff;
}
.follow_drawer_btn {
  display: inline-block;
  font-size: 12px;
  padding: 2px 6px;
  border-radius: 4px;
  color: #409eff;
  background: #ecf5ff;
  border: 1px solid #b3d8ff;
}
.follow_drawer_btn:hover {
  background: #409eff;
  border-color: #409eff;
  color: #fff;
}
</style>
